module.exports = __webpack_public_path__ + "static/media/logo-sizex.4893c390.png";